/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import {useIntl} from 'react-intl';
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub';
import {SidebarMenuItem} from './SidebarMenuItem';
import {useAuth} from 'src/app/modules/auth';
import {CheckRole} from 'src/utils/utils';

const SidebarMenuMain = () => {
  const {currentUser} = useAuth();
  const currentPermissions = currentUser?.permissions;

  return (
    <>
      <SidebarMenuItem to='/dashboard' icon='/media/icons/duotune/art/art002.svg' title={'Trang chủ'} fontIcon='bi-app-indicator' />
      {(CheckRole(currentPermissions, ['Permissions.HeThong.Manage']) ||
        CheckRole(currentPermissions, ['Permissions.DonVi.Manage']) ||
        CheckRole(currentPermissions, ['Permissions.DanhMucChung.Manage'])) && (
        <SidebarMenuItemWithSub to='/quan-ly-thiet-bi' title='Danh mục' icon='/media/icons/duotune/files/fil015.svg' fontIcon='bi-person'>
          {(CheckRole(currentPermissions, ['Permissions.HeThong.Manage']) || CheckRole(currentPermissions, ['Permissions.DonVi.Manage'])) && (
            <SidebarMenuItem to='/quan-ly-thiet-bi/branches' title='Đơn vị kinh doanh' hasBullet={true} />
          )}
          <SidebarMenuItem to='/quan-ly-thiet-bi/devices' title='Thiết bị' hasBullet={true} />
          {CheckRole(currentPermissions, ['Permissions.HeThong.Manage']) && (
            <SidebarMenuItem to='/quan-ly-thiet-bi/merchantpayments' title='IPN VNPay' hasBullet={true} />
          )}
          <SidebarMenuItem to='/quan-ly-thiet-bi/devicebills' title='Lịch sử thanh toán của thiết bị' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}
      {(CheckRole(currentPermissions, ['Permissions.HeThong.Manage']) ||
        CheckRole(currentPermissions, ['Permissions.DonVi.Manage']) ||
        CheckRole(currentPermissions, ['Permissions.BaoCao.Manage'])) && (
        <SidebarMenuItemWithSub to='/bao-cao' title='Thống kê báo cáo' icon='/media/icons/duotune/graphs/gra001.svg' fontIcon='bi-person'>
          <SidebarMenuItem to='/bao-cao/branches-sales' title='Chi tiết giao dịch của đơn vị' hasBullet={true} />
          <SidebarMenuItem to='/bao-cao/devices-sales' title='Tình hình kinh doanh của thiết bị' hasBullet={true} />
          {/* <SidebarMenuItem to='/bao-cao/bankaccounts' title='Tình hình sử dụng thiết bị' hasBullet={true} /> */}
        </SidebarMenuItemWithSub>
      )}
      {CheckRole(currentPermissions, [
        'Permissions.HeThong.Manage',
        'Permissions.DonVi.Manage',
        'Permissions.AuditTrails.Search',
        'Permissions.LoginLogs.Search',
      ]) && (
        <SidebarMenuItemWithSub to='/he-thong' title='Hệ thống' fontIcon='bi-sticky' icon='/media/icons/duotune/coding/cod001.svg'>
          {/*           <SidebarMenuItem to='/he-thong/vai-tro' title='Vai trò người dùng' hasBullet={true} />
           */}{' '}
          {CheckRole(currentPermissions, ['Permissions.HeThong.Manage', 'Permissions.DonVi.Manage']) && (
            <SidebarMenuItem to='/he-thong/nguoi-dung' title='Người dùng' hasBullet={true} />
          )}
          {/* <SidebarMenuItem to='/he-thong/chi-nhanh' title='Cơ cấu tổ chức' hasBullet={true} /> */}
          {CheckRole(currentPermissions, ['Permissions.HeThong.Manage']) && (
            <SidebarMenuItem to='/he-thong/tham-so-he-thong' title='Tham số hệ thống' hasBullet={true} />
          )}
          {CheckRole(currentPermissions, ['Permissions.AuditTrails.Search']) && (
            <SidebarMenuItem to='/he-thong/nhat-ky-hoat-dong' title='Nhật ký hoạt động' hasBullet={true} />
          )}
          {CheckRole(currentPermissions, ['Permissions.LoginLogs.Search']) && (
            <SidebarMenuItem to='/he-thong/nhat-ky-dang-nhap' title='Nhật ký đăng nhập' hasBullet={true} />
          )}
          {CheckRole(currentPermissions, ['Permissions.HeThong.Manage']) && (
            <SidebarMenuItem to='/he-thong/hardware-debug' title='Debug' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}
    </>
  );
};

export {SidebarMenuMain};
